import script from "./ScopeImport.vue?vue&type=script&setup=true&lang=js"
export * from "./ScopeImport.vue?vue&type=script&setup=true&lang=js"

import "./ScopeImport.vue?vue&type=style&index=0&id=6f8dcbdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8dcbdc"]])

export default __exports__